import type { FC } from 'react'
import styled from '@emotion/styled'
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share'

import Typography from '@segment/matcha/components/Typography'
import { FacebookIcon, LinkedinIcon, TwitterIcon } from '@segment/matcha/components/Icons/SocialMedia'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

interface ShareLessonProps {
  slug?: string
}

const copy = { title: `Share this lesson` }

const ShareLesson: FC<ShareLessonProps> = ({ slug }) => {
  const pageConfig = usePageConfig()
  const shareUrl = getAbsoluteUrl(`/growth-masters/${slug}/`, pageConfig)

  return (
    <Wrapper>
      <StyledTypography tag="p" variant="h5">
        {copy.title}
      </StyledTypography>
      <LinksWrapper>
        <IconWrapper>
          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon size="nav" />
          </LinkedinShareButton>
        </IconWrapper>

        <IconWrapper>
          <TwitterShareButton url={shareUrl}>
            <TwitterIcon size="nav" />
          </TwitterShareButton>
        </IconWrapper>

        <IconWrapper>
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon size="nav" />
          </FacebookShareButton>
        </IconWrapper>
      </LinksWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  justify-content: start;
  padding: 24px 0;
`

const StyledTypography = styled(Typography)`
  margin: 12px 0;
`

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
`

const LinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
`
export default ShareLesson
